// extracted by mini-css-extract-plugin
export default {"scrollableContent":"QFWNWY1x0AlUis9iuAMp"};